import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CLINIC } from "@/data/site";
import { DEFAULT_TIMINGS, toDisplay, toSchedule } from "@/lib/timings";

const ContentContext = createContext(null);

// Defaults that mirror the backend content shape, with derived helpers.
const DEFAULTS = {
  doctorName: CLINIC.doctorName,
  qualifications: CLINIC.qualifications,
  title: CLINIC.title,
  experience: CLINIC.experience,
  clinicName: CLINIC.clinicName,
  tagline: CLINIC.tagline,
  address: CLINIC.address,
  doctorMobile: CLINIC.doctorMobile,
  appointmentMobile: CLINIC.appointmentMobile,
  email: CLINIC.email,
  whatsapp: CLINIC.whatsapp,
  instagram: "https://www.instagram.com/",
  timings: DEFAULT_TIMINGS,
  heroHeadline: "Expert Care for Every Chapter of a Woman's Life",
  heroSupporting:
    "Compassionate, experienced obstetric and gynaecological care with a personal approach — from adolescence and routine women's health to pregnancy, maternity and beyond.",
  aboutBio:
    "For over 25 years, Dr. Mithee Bhanot has cared for women through every stage of life with warmth, precision and genuine understanding. Trained in India and the United Kingdom, she brings together clinical excellence and a deeply personal approach — taking the time to listen, explain and reassure. Her practice is built on trust, individualised care and patient education, so every woman feels informed, respected and supported.",
  clinicDescription: "A calm, private and welcoming space dedicated entirely to women's health in Sector-110, Noida.",
};

function derive(raw) {
  const merged = { ...DEFAULTS, ...(raw || {}) };
  merged.qualificationList = (merged.qualifications || "")
    .split(",")
    .map((q) => q.trim())
    .filter(Boolean);
  merged.whatsappDigits = (merged.whatsapp || "").replace(/[^0-9]/g, "");
  const timings = Array.isArray(merged.timings) && merged.timings.length ? merged.timings : DEFAULT_TIMINGS;
  merged.timingsList = toDisplay(timings);
  merged.schedule = toSchedule(timings);
  return merged;
}

export function ContentProvider({ children }) {
  const [content, setContent] = useState(derive(null));

  useEffect(() => {
    api.get("/content").then((r) => setContent(derive(r.data))).catch(() => {});
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export function useContent() {
  return useContext(ContentContext) || derive(null);
}
